import { ITestAccount } from "./testAccount.types"

export class TestAccount implements ITestAccount {
  constructor(
    public accountNum?: string,
    public billingAccId?: number,
    public fuelType?: string,
    public latestStatus?: string,
    public insideRenewalWindow?: boolean,
    public isActiveAgreement?: boolean,
    public multiMeterpoints?: boolean,
    public isSeasonal?: boolean,
    public toDate?: string,
  ) {}
}
